import * as React from 'react';
import { Card } from '../';
import Loader from '../Loader/Loader';

declare var process: any;

interface Props {
  vehicles: IVehicle[];
  onClick: (IVehicle) => void;
  loading?: boolean;
}

export default ({ vehicles, onClick, loading }: Props) => (
  <div className="servicing-table">
    <Card list>
      {!loading ? (
        <table>
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Remaining Mileage</th>
            </tr>
          </thead>
          <tbody>
            {vehicles.map((vehicle) => (
              <tr key={vehicle.id} onClick={() => onClick(vehicle)}>
                <td>
                  <div className="media">
                    <figure className="media-left">
                      <span className="avatar image is-32x32">
                        <img
                          src={`${process.env.API_URL}/vehicles/types/${
                            vehicle.vehicle_type.id
                          }/image`}
                        />
                      </span>
                    </figure>
                    <div className="media-content">
                      {vehicle.registration}
                      <br />
                      <small>{vehicle.vehicle_type.name}</small>
                    </div>
                  </div>
                </td>
                <td>
                  <strong
                    className={
                      vehicle.remaining_service_mileage <= 0 ? 'danger' : ''
                    }
                  >
                    {vehicle.remaining_service_mileage}
                  </strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Loader fullwidth />
      )}
    </Card>
  </div>
);
